import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../Services/api";
import "./index.css";
import LogoPalmares from "../../Imagens/logoWhite.png";
import "bootstrap/dist/css/bootstrap.min.css";

const Index = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");

  useEffect(function () {
    localStorage.removeItem("usuarioLogado");
    localStorage.removeItem("palmaresAuthToken");
  }, []);

  async function ValidaUsuario() {
    localStorage.removeItem("usuarioLogado");
    localStorage.removeItem("palmaresAuthToken");
    let retorno = await buscaUsuario();

    if (retorno.status === 200) {
      if (retorno.data.Usuario.tipo === 0) {
        localStorage.setItem("palmaresAuthToken", retorno.data.Token);
        localStorage.setItem("usuarioLogado", JSON.stringify(retorno.data.Usuario));
        if (localStorage.getItem("usuarioLogado") === null) {
          console.log("Nao Entrou !!!");
        } else {
          // console.log(retorno.data.Usuario);
          console.log("Usuario Logado!");
          navigate("/Menu");
        }
      } else {
        document.getElementById("msm_senha").innerText =
          "Usuario sem permissao de acesso!";
        document.getElementById("msm_senha").style.display = "block";
      }
    } else {
      document.getElementById("msm_senha").innerText =
        "Usuario e senha nao conferem!";
      document.getElementById("msm_senha").style.display = "block";
    }
  }

  async function buscaUsuario() {
    let formData = new FormData();

    formData.append("login", usuario);
    formData.append("senha", password);

    try {
      const response = await api.post("/usuario/login", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  return (
    <div className="TelaLoginInicial">
      <div className="login-shell">
        <section className="login-brand-panel">
          <div id="painelLOGO">
            <img src={LogoPalmares} alt="Logo Prisma Route"></img>
          </div>

          <div className="login-brand-copy">
            <span className="login-brand-kicker">Prisma Route</span>
          </div>

          <div className="login-highlights">
            <div className="login-highlight-card">
              <strong>Roteirizacao</strong>
              <span>
                Sequencia de carregamento e entrega com foco em eficiencia.
              </span>
            </div>
            <div className="login-highlight-card">
              <strong>Operacao em campo</strong>
              <span>
                Status em tempo real, ocorrencias e historico das visitas.
              </span>
            </div>
            <div className="login-highlight-card">
              <strong>Base integrada</strong>
              <span>
                Integrado com sistema interno de vendas e notas.
              </span>
            </div>
          </div>
        </section>

        <section className="PainelLogin">
          <div className="login-container">
            <div className="login-card-header">
              <span className="login-card-badge">Acesso ao sistema</span>
              <p style={{fontSize:'0.7em'}}>
                Use suas credenciais para acompanhar rotas, entregas e
                ocorrencias.
              </p>
            </div>

            <form>
              <div className="form-group mb-3" align="left">
                <label htmlFor="usuario" className="form-label">
                  Usuario
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  id="usuario"
                  placeholder="Digite seu usuario"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                />
              </div>
              <div className="form-group mb-4" align="left">
                <label htmlFor="senha" className="form-label">
                  Senha
                </label>
                <input
                  type="password"
                  className="form-control form-control-lg"
                  id="senha"
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      ValidaUsuario();
                    }
                  }}
                />
              </div>
              <button
                type="button"
                className="btn btn-primary btn-lg w-100 login-submit-button"
                onClick={() => ValidaUsuario()}
              >
                Entrar
              </button>
              <label id="msm_senha">Usuario e senha nao conferem!</label>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Index;
